import { reactive, watch, ref } from 'vue'
import { useToast } from 'primevue/usetoast';

export const toastStore = reactive({
    toasts: []
})

export const useToastStore = () => {
    const toast = useToast()
    watch(
        () => toastStore.toasts,
        (toasts) => {
            //toast.removeAllGroups()
            toasts.length && toast.add(toasts[toasts.length - 1])
        },
        {deep: true}
    )
}
